import { QuotationsState, QuotationTypes } from '../actions/quotations/quotations.d';
import {
  ADD_SEARCH_STRING,
  CLEAR_SEARCH_STRING,
  FETCH_QUOTATIONS_COMPLETED,
  FETCH_QUOTATIONS_ERROR,
  FETCH_QUOTATIONS_STARTED,
  UPDATE_QUOTATIONS_CURRENT_PAGE,
  UPDATE_QUOTATIONS_PAGE_SIZE,
  SORT_QUOTATIONS,
  CLEAR_QUOTATIONS,
} from 'redux/actionTypes/quotations';

const INITIAL_STATE: QuotationsState = {
  data: [],
  error: false,
  submitted: false,
  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
    nextPage: 0,
    prevPage: null,
    isFirstPage: false,
    isLastPage: false,
    startAt: null,
    endAt: null,
  },
  q: '',
  sorted: [],
};

function quotationsReducer(state = INITIAL_STATE, action: QuotationTypes): QuotationsState {
  switch (action.type) {
    case FETCH_QUOTATIONS_STARTED: {
      return {
        ...state,
        submitted: true,
      };
    }
    case FETCH_QUOTATIONS_COMPLETED: {
      return {
        ...state,
        ...action.payload,
        submitted: false,
      };
    }
    case FETCH_QUOTATIONS_ERROR: {
      return {
        ...state,
        error: true,
        submitted: false,
      };
    }
    case UPDATE_QUOTATIONS_CURRENT_PAGE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.currentPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case UPDATE_QUOTATIONS_PAGE_SIZE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.perPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case ADD_SEARCH_STRING: {
      return {
        ...state,
        q: action.payload,
      };
    }

    case CLEAR_SEARCH_STRING: {
      return {
        ...state,
        q: '',
      };
    }

    case SORT_QUOTATIONS: {
      return {
        ...state,
        sorted: action.payload,
      };
    }

    case CLEAR_QUOTATIONS: {
      return {
        ...state,
        sorted: [],
      };
    }

    default:
      return state;
  }
}

export default quotationsReducer;
